export default "__VITE_ASSET__BXCKTs49__"